import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SignedEditionView } from "./SignedEditionView";
import { SignedEditionViewStore } from "../../store/SignedEditionViewStore";
import { useStore } from "../../../../hooks";

export const SignedEditionViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/signedEdition/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SignedEditionViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "signedEdition",
              label: rootStore.langStore.groupSignedEditionSignedEditionLabel,
            },
            {
              id: "editionContracts",
              label:
                (
                  {
                    es: "Documentación firmada",
                    en: "Signed documentation",
                    pt: "Documentação assinada",
                  } as Record<string, string>
                )[rootStore.langStore.language] ?? "Documentación firmada",
            },
            {
              id: "dndaTracking",
              label: rootStore.langStore.groupSignedEditionDndaTrackingLabel,
            },
            {
              id: "sadaicTracking",
              label: rootStore.langStore.groupSignedEditionSadaicTrackingLabel,
            },
            {
              id: "systemDates",
              label: rootStore.langStore.groupSignedEditionSystemDatesLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SignedEditionView signedEditionViewStore={store} />
      </PageLayout>
    </div>
  );
});
